import { render, staticRenderFns } from "./c_upload_img.vue?vue&type=template&id=b3e502c6&scoped=true"
import script from "./c_upload_img.vue?vue&type=script&lang=js"
export * from "./c_upload_img.vue?vue&type=script&lang=js"
import style0 from "./c_upload_img.vue?vue&type=style&index=0&id=b3e502c6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e502c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3e502c6')) {
      api.createRecord('b3e502c6', component.options)
    } else {
      api.reload('b3e502c6', component.options)
    }
    module.hot.accept("./c_upload_img.vue?vue&type=template&id=b3e502c6&scoped=true", function () {
      api.rerender('b3e502c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_upload_img.vue"
export default component.exports